window.initCardFillHover = function initCardFillHover() {
  const cardFillHoverElsArr = document.querySelectorAll('.card-fill-hover');

  if (cardFillHoverElsArr.length) {
    cardFillHoverElsArr.forEach((cardFillHoverEl) => {
      if (!cardFillHoverEl.classList.contains('is-init-card-fill-hover')) {
        cardFillHoverEl.classList.add('is-init-card-fill-hover');

        const cardFillBgEl = document.createElement('div');
        cardFillBgEl.classList.add('card-fill-hover__fill-bg');
        cardFillHoverEl.appendChild(cardFillBgEl);

        const handleOrigin = (e) => {
          const rect = cardFillHoverEl.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          cardFillBgEl.style.left = `${x}px`;
          cardFillBgEl.style.top = `${y}px`;
        };

        const handleHoverColor = () => {
          const computedStyle = getComputedStyle(cardFillHoverEl);
          const borderColor = computedStyle.borderColor;

          if (
            borderColor &&
            borderColor !== 'transparent' &&
            borderColor !== 'rgba(0, 0, 0, 0)'
          ) {
            const index = [...cardFillHoverElsArr].indexOf(cardFillHoverEl);
            const varName = `--card-hover-color-${index}`;

            cardFillHoverEl.style.setProperty(varName, borderColor);
            cardFillHoverEl.style.setProperty(
              '--card-hover-color',
              borderColor
            );
          }
        };

        cardFillHoverEl.addEventListener('mouseenter', (e) => {
          if (window.innerWidth > 1024) {
            handleOrigin(e);
          }
          handleHoverColor();
        });

        cardFillHoverEl.addEventListener('mouseleave', (e) => {
          if (window.innerWidth > 1024) {
            handleOrigin(e);
          }
        });

        handleHoverColor();
      }
    });
  }
};

initCardFillHover();
